import { SVGIconComponent } from './types';

export const HubLayout: SVGIconComponent = ({ className, color, style }) => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 18 18"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ color, ...style }}
    className={className}
  >
    <title>module/layout</title>
    <g id="module/layout" stroke="none" fill="none" fillRule="nonzero">
      <path
        d="M14.2024046,10.1516416 L14.5847366,10.1516416 C14.9370311,10.1516416 15.221938,9.85949596 15.221938,9.49992329 C15.221938,9.13960271 14.9362999,8.84820501 14.5847366,8.84820501 L14.2024046,8.84820501 C13.8501101,8.84820501 13.5652033,9.14035062 13.5652033,9.49992329 C13.5652033,9.85949596 13.8508414,10.1516416 14.2024046,10.1516416 Z"
        id="Path"
        fill="currentColor"
      ></path>
      <path
        d="M16.8791393,10.1516416 L17.2614713,10.1516416 C17.6137658,10.1516416 17.8986727,9.85949596 17.8986727,9.49992329 C17.8986727,9.13960271 17.6130346,8.84820501 17.2614713,8.84820501 L16.8791393,8.84820501 C16.5268448,8.84820501 16.241938,9.14035062 16.241938,9.49992329 C16.241938,9.85949596 16.5275761,10.1516416 16.8791393,10.1516416 Z"
        id="Path-Copy-15"
        fill="currentColor"
      ></path>
      <path
        d="M6.55520116,8.84759134 L6.17286911,8.84759134 C5.82057463,8.84759134 5.53566778,9.13973695 5.53566778,9.49930962 C5.53566778,9.8596302 5.82130588,10.1510279 6.17286911,10.1510279 L6.55520116,10.1510279 C6.90749564,10.1510279 7.19240248,9.85888229 7.19240248,9.49930962 C7.19240248,9.13973695 6.90749564,8.84759134 6.55520116,8.84759134 Z"
        id="Path"
        fill="currentColor"
      ></path>
      <path
        d="M9.14064404,8.84759134 L8.758312,8.84759134 C8.40601751,8.84759134 8.12111067,9.13973695 8.12111067,9.49930962 C8.12111067,9.8596302 8.40674876,10.1510279 8.758312,10.1510279 L9.14064404,10.1510279 C9.49293853,10.1510279 9.77784537,9.85888229 9.77784537,9.49930962 C9.77784537,9.13973695 9.49293853,8.84759134 9.14064404,8.84759134 Z"
        id="Path"
        fill="currentColor"
      ></path>
      <path
        d="M11.5262115,10.1516416 L11.9085436,10.1516416 C12.260838,10.1516416 12.5457449,9.85949596 12.5457449,9.49992329 C12.5457449,9.13960271 12.2601068,8.84820501 11.9085436,8.84820501 L11.5262115,8.84820501 C11.173917,8.84820501 10.8890102,9.14035062 10.8890102,9.49992329 C10.8890102,9.85949596 11.1746483,10.1516416 11.5262115,10.1516416 L11.5262115,10.1516416 Z"
        id="Path"
        fill="currentColor"
      ></path>
      <path
        d="M3.87900808,8.84759134 L3.49667603,8.84759134 C3.14438155,8.84759134 2.85947471,9.13973695 2.85947471,9.49930962 C2.85947471,9.8596302 3.1451128,10.1510279 3.49667603,10.1510279 L3.87900808,10.1510279 C4.23130257,10.1510279 4.51620941,9.85888229 4.51620941,9.49930962 C4.51620941,9.13973695 4.23057131,8.84759134 3.87900808,8.84759134 Z"
        id="Path"
        fill="currentColor"
      ></path>
      <path
        d="M1.16279867,8.84759134 L0.780466626,8.84759134 C0.428172142,8.84759134 0.143265298,9.13973695 0.143265298,9.49930962 C0.143265298,9.8596302 0.428903394,10.1510279 0.780466626,10.1510279 L1.16279867,10.1510279 C1.51509316,10.1510279 1.8,9.85888229 1.8,9.49930962 C1.8,9.13973695 1.5143619,8.84759134 1.16279867,8.84759134 Z"
        id="Path-Copy-16"
        fill="currentColor"
      ></path>
      <path
        d="M14.2024046,16.1516416 L14.5847366,16.1516416 C14.9370311,16.1516416 15.221938,15.859496 15.221938,15.4999233 C15.221938,15.1396027 14.9362999,14.848205 14.5847366,14.848205 L14.2024046,14.848205 C13.8501101,14.848205 13.5652033,15.1403506 13.5652033,15.4999233 C13.5652033,15.859496 13.8508414,16.1516416 14.2024046,16.1516416 Z"
        id="Path-Copy-5"
        fill="currentColor"
      ></path>
      <path
        d="M6.55520116,14.8475913 L6.17286911,14.8475913 C5.82057463,14.8475913 5.53566778,15.1397369 5.53566778,15.4993096 C5.53566778,15.8596302 5.82130588,16.1510279 6.17286911,16.1510279 L6.55520116,16.1510279 C6.90749564,16.1510279 7.19240248,15.8588823 7.19240248,15.4993096 C7.19240248,15.1397369 6.90749564,14.8475913 6.55520116,14.8475913 Z"
        id="Path-Copy-4"
        fill="currentColor"
      ></path>
      <path
        d="M9.14064404,14.8475913 L8.758312,14.8475913 C8.40601751,14.8475913 8.12111067,15.1397369 8.12111067,15.4993096 C8.12111067,15.8596302 8.40674876,16.1510279 8.758312,16.1510279 L9.14064404,16.1510279 C9.49293853,16.1510279 9.77784537,15.8588823 9.77784537,15.4993096 C9.77784537,15.1397369 9.49293853,14.8475913 9.14064404,14.8475913 Z"
        id="Path-Copy-3"
        fill="currentColor"
      ></path>
      <path
        d="M11.5262115,16.1516416 L11.9085436,16.1516416 C12.260838,16.1516416 12.5457449,15.859496 12.5457449,15.4999233 C12.5457449,15.1396027 12.2601068,14.848205 11.9085436,14.848205 L11.5262115,14.848205 C11.173917,14.848205 10.8890102,15.1403506 10.8890102,15.4999233 C10.8890102,15.859496 11.1746483,16.1516416 11.5262115,16.1516416 L11.5262115,16.1516416 Z"
        id="Path-Copy-2"
        fill="currentColor"
      ></path>
      <path
        d="M3.87900808,14.8475913 L3.49667603,14.8475913 C3.14438155,14.8475913 2.85947471,15.1397369 2.85947471,15.4993096 C2.85947471,15.8596302 3.1451128,16.1510279 3.49667603,16.1510279 L3.87900808,16.1510279 C4.23130257,16.1510279 4.51620941,15.8588823 4.51620941,15.4993096 C4.51620941,15.1397369 4.23057131,14.8475913 3.87900808,14.8475913 Z"
        id="Path-Copy"
        fill="currentColor"
      ></path>
      <path
        d="M14.2024046,4.15164157 L14.5847366,4.15164157 C14.9370311,4.15164157 15.221938,3.85949596 15.221938,3.49992329 C15.221938,3.13960271 14.9362999,2.84820501 14.5847366,2.84820501 L14.2024046,2.84820501 C13.8501101,2.84820501 13.5652033,3.14035062 13.5652033,3.49992329 C13.5652033,3.85949596 13.8508414,4.15164157 14.2024046,4.15164157 Z"
        id="Path-Copy-10"
        fill="currentColor"
      ></path>
      <path
        d="M6.55520116,2.84759134 L6.17286911,2.84759134 C5.82057463,2.84759134 5.53566778,3.13973695 5.53566778,3.49930962 C5.53566778,3.8596302 5.82130588,4.1510279 6.17286911,4.1510279 L6.55520116,4.1510279 C6.90749564,4.1510279 7.19240248,3.85888229 7.19240248,3.49930962 C7.19240248,3.13973695 6.90749564,2.84759134 6.55520116,2.84759134 Z"
        id="Path-Copy-9"
        fill="currentColor"
      ></path>
      <path
        d="M9.14064404,2.84759134 L8.758312,2.84759134 C8.40601751,2.84759134 8.12111067,3.13973695 8.12111067,3.49930962 C8.12111067,3.8596302 8.40674876,4.1510279 8.758312,4.1510279 L9.14064404,4.1510279 C9.49293853,4.1510279 9.77784537,3.85888229 9.77784537,3.49930962 C9.77784537,3.13973695 9.49293853,2.84759134 9.14064404,2.84759134 Z"
        id="Path-Copy-8"
        fill="currentColor"
      ></path>
      <path
        d="M11.5262115,4.15164157 L11.9085436,4.15164157 C12.260838,4.15164157 12.5457449,3.85949596 12.5457449,3.49992329 C12.5457449,3.13960271 12.2601068,2.84820501 11.9085436,2.84820501 L11.5262115,2.84820501 C11.173917,2.84820501 10.8890102,3.14035062 10.8890102,3.49992329 C10.8890102,3.85949596 11.1746483,4.15164157 11.5262115,4.15164157 L11.5262115,4.15164157 Z"
        id="Path-Copy-7"
        fill="currentColor"
      ></path>
      <path
        d="M3.87900808,2.84759134 L3.49667603,2.84759134 C3.14438155,2.84759134 2.85947471,3.13973695 2.85947471,3.49930962 C2.85947471,3.8596302 3.1451128,4.1510279 3.49667603,4.1510279 L3.87900808,4.1510279 C4.23130257,4.1510279 4.51620941,3.85888229 4.51620941,3.49930962 C4.51620941,3.13973695 4.23057131,2.84759134 3.87900808,2.84759134 Z"
        id="Path-Copy-6"
        fill="currentColor"
      ></path>
      <path
        d="M8.9773312,13.194479 C9.32962569,13.194479 9.61453253,12.9023334 9.61453253,12.5427608 L9.61453253,12.1517183 C9.61453253,11.7913977 9.32889444,11.5 8.9773312,11.5 C8.62503672,11.5 8.34012847,11.7921456 8.34012847,12.1517183 L8.34012847,12.5427608 C8.33939731,12.9030813 8.62503672,13.194479 8.9773312,13.194479 Z"
        id="Path"
        fill="currentColor"
      ></path>
      <path
        d="M8.9773312,7.54411643 C9.32962569,7.54411643 9.61453253,7.25197083 9.61453253,6.89239815 L9.61453253,6.50135568 C9.61453253,6.1410351 9.32889444,5.8496374 8.9773312,5.8496374 C8.62503672,5.8496374 8.34012847,6.14178301 8.34012847,6.50135568 L8.34012847,6.89239815 C8.33939731,7.25271874 8.62503672,7.54411643 8.9773312,7.54411643 Z"
        id="Path"
        fill="currentColor"
      ></path>
      <path
        d="M17.2627987,13.194479 C17.6150932,13.194479 17.9,12.9023334 17.9,12.5427608 L17.9,12.1517183 C17.9,11.7913977 17.6143619,11.5 17.2627987,11.5 C16.9105042,11.5 16.6255959,11.7921456 16.6255959,12.1517183 L16.6255959,12.5427608 C16.6248648,12.9030813 16.9105042,13.194479 17.2627987,13.194479 Z"
        id="Path-Copy-12"
        fill="currentColor"
      ></path>
      <path
        d="M17.2627987,7.54411643 C17.6150932,7.54411643 17.9,7.25197083 17.9,6.89239815 L17.9,6.50135568 C17.9,6.1410351 17.6143619,5.8496374 17.2627987,5.8496374 C16.9105042,5.8496374 16.6255959,6.14178301 16.6255959,6.50135568 L16.6255959,6.89239815 C16.6248648,7.25271874 16.9105042,7.54411643 17.2627987,7.54411643 Z"
        id="Path-Copy-11"
        fill="currentColor"
      ></path>
      <path
        d="M0.737202733,13.194479 C1.08949722,13.194479 1.37440406,12.9023334 1.37440406,12.5427608 L1.37440406,12.1517183 C1.37440406,11.7913977 1.08876597,11.5 0.737202733,11.5 C0.384908249,11.5 0.1,11.7921456 0.1,12.1517183 L0.1,12.5427608 C0.0992688419,12.9030813 0.384908249,13.194479 0.737202733,13.194479 Z"
        id="Path-Copy-14"
        fill="currentColor"
      ></path>
      <path
        d="M0.737202733,7.54411643 C1.08949722,7.54411643 1.37440406,7.25197083 1.37440406,6.89239815 L1.37440406,6.50135568 C1.37440406,6.1410351 1.08876597,5.8496374 0.737202733,5.8496374 C0.384908249,5.8496374 0.1,6.14178301 0.1,6.50135568 L0.1,6.89239815 C0.0992688419,7.25271874 0.384908249,7.54411643 0.737202733,7.54411643 Z"
        id="Path-Copy-13"
        fill="currentColor"
      ></path>
    </g>
  </svg>
);
